import { useTranslation } from 'react-i18next';

import { StatusToast, StatusToastVariant } from '@this+that/ui';
import { LuUndo } from 'react-icons/lu';

import { UNDO_WINDOW_MS } from '../../utils/constants/pendingActions';

interface UndoToastProps {
  message: string;
  onUndo: () => void;
  onClose?: () => void;
  durationMs?: number;
}

export function UndoToast({
  message,
  onUndo,
  onClose,
  durationMs = UNDO_WINDOW_MS,
}: Readonly<UndoToastProps>) {
  const { t } = useTranslation();

  return (
    <StatusToast
      status={StatusToastVariant.Undo}
      message={message}
      action={{
        label: t('doBox.undoToast.undo'),
        icon: <LuUndo />,
        onClick: onUndo,
      }}
      onClose={onClose}
      durationMs={durationMs}
      dataTestId="undo-toast"
    />
  );
}
